import React, { useEffect, useState }                             from 'react'
import axios                                                      from 'axios'
import { Grid, Typography }                                       from'@material-ui/core'
import { CLIENT_PUBLIC_TOKEN }                                    from '../../config'
import { node_server }                                            from '../../Helpers'

const GetFirstLoginOnly = () => {

   const [ listToDisplay,     setListToDisplay  ]  =  useState()
   
   const handleClick = async (userId) => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.put(node_server + `admin/analytics/reset/${userId}`)
         .then( res => console.log('GetFirstLoginOnly res.data is', res.data ))
   }

   useEffect( () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.get(node_server + 'admin/analytics/getFirstLoginOnly')
         .then( res => res.data )
         .then( data => {
            setListToDisplay(
               data.data.map( (d, i) => {
                  console.log('d is', d)
                  return(
                     <Typography key={d.userId} onClick={() => handleClick(d.userId)} >
                        { d.username }
                     </Typography>
                  )
               })
            )
         })
         .catch( (error) => {
            console.error(error)
         })
   }, [])

   return(
      <Grid>
         <Typography>
            First Login Only
         </Typography>
         <Grid item xs={12} align='left' style={{ border: '2px solid darkgray', borderRadius: '0.5rem', height: '250px', marginTop: '2rem', overflow: 'scroll', padding: '1rem', width: '35rem' }} >
            <Typography>
               { listToDisplay }
            </Typography>
         </Grid>
      </Grid>
   )
}

export default GetFirstLoginOnly
